import { TableColumn } from "../table/TableColumn";

const PresetInputColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        sortByName: "settingType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
    },
    {
        heading: "Used By",
        accessor: "usedBy",
        isNumeric: false,
        id: 2,
        // sortByName: "settingType.settingDist",
        // sortDirection: "asc",
        active: true,
        translationKey: "usedBy"
    },
];

export default PresetInputColumns;
